
import './App.css';
import { useEffect, useState } from 'react';
import Login from './components/login/Login';
import { Routes, Route } from 'react-router-dom';
import CallLogs from './components/call_logs/CallLogs';
import AgentDetailsForm from './components/agent_details_form/AgentDetailsForm';
import React from 'react';


function App() {
  const [agentId, setagentId] = useState('');

  useEffect(() => {
    console.log(agentId, "id...");
  }, [agentId])

  
  return (
    < >
      <Routes>
       
        <Route path='/offline-frontend' element={<Login setagentId={setagentId} agentId={agentId} />} />
        <Route path='/offline-frontend/leadlist/:agentId' element={<CallLogs agentId={agentId} />} />
        <Route path='/offline-frontend/leadlist/:agentId/:id' element={<AgentDetailsForm />} />
      </Routes>
    </>
  );
}

export default App;
